import React, { useContext } from 'react';
import * as R from 'ramda';
import { CardContent } from '@mui/material';
import { store } from '../store';
import AppIcon from '@mui/icons-material/Apps';
import GuidIcon from '@mui/icons-material/Fingerprint';
import InfoIcon from '@mui/icons-material/Info';
import { CenterProgress } from '../../component/CenterProgress';
import { Route, useHistory } from 'react-router-dom';
import CardCD from '../../component/CardCD';
import CardCDTitle from '../../component/CardCDTitle';
import { LabelValueRHF, CardTitleCD } from '@cd/rhf';
import { ROUTE_BASE_APPS } from './vars';
import useGetApp from '../fetch/useGetApp';
import AppParams from './AppParams';
import { css } from '@emotion/react';

const styles = {
	cards: css({
		display: 'flex',
		flexWrap: 'wrap',
		padding: '8px',
		marginTop: '16px',
		marginBottom: '8px',
		'& > *': {
			width: '200px',
			marginRight: '8px',
			marginBottom: '8px'
		}
	})
};

function getSettings(data) {
	return (
		<Route
			path={`${ROUTE_BASE_APPS}/:appID/settings/:verb/:id?`}
			render={props => (
				<CardCD title={<CardCDTitle title="PARAMETERS" />}>
					<AppParams {...props} />
				</CardCD>
			)}
		/>
	);
}

const App = ({ match }) => {
	const { dispatch } = useContext(store);
	const history = useHistory();
	const { appID } = (match && match.params) || 0;
	const { isLoading, isError, data, error } = useGetApp(appID, dispatch);

	if (isError) {
		return <div>{JSON.stringify(error)}</div>;
	}

	if (isLoading) {
		return <CenterProgress />;
	}
	if (!data || R.isEmpty(data)) {
		return <div>NO DATA</div>;
	}

	const { id, app_name, guid } = data;

	return (
		<div>
			<CardCD
				title={
					<CardTitleCD
						css={{ pointer: 'cursor' }}
						title="APP INFO"
						onClick={() => {
							history.goBack();
						}}
					/>
				}>
				<CardContent>
					<LabelValueRHF label="ID" value={id} Icon={InfoIcon} />
					<LabelValueRHF
						label="NAME"
						value={app_name}
						Icon={AppIcon}
					/>
					<LabelValueRHF label="GUID" value={guid} Icon={GuidIcon} />

					<Route
						path={`${ROUTE_BASE_APPS}/:appID`}
						exact
						render={props => (
							<div css={styles.cards}>
								<CardCD
									title="PARAMETERS"
									okButtonTitle=""
									subtitle=""
									onClick={() =>
										history.push(
											`${ROUTE_BASE_APPS}/${appID}/settings/all`
										)
									}
									clickable>
									<span>Application Parameters</span>
								</CardCD>
							</div>
						)}
					/>
				</CardContent>
			</CardCD>
			{getSettings(data)}
		</div>
	);
};

const RedirApp = () => (
	<Route
		path={`${ROUTE_BASE_APPS}/:appID`}
		render={props => <App {...props} />}
	/>
);

export default RedirApp;
